import { Processo } from "./Processo";

export class ProcessoAdvogado{
    id = 0;
    idFuncionario = 0;
    idProcesso = 0;
    idAdvogado = 0;
    dataHoraInserir =  new Date();
    dataHoraDesligar =  new Date();
    situacao = false;  
    nome = '';
    oab = '';
}